import React from "react";
import { fade, makeStyles, withStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import SearchIcon from "@material-ui/icons/Search";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemText from "@material-ui/core/ListItemText";
import Avatar from "@material-ui/core/Avatar";
import Badge from "@material-ui/core/Badge";
import Card from "@material-ui/core/Card";
import InputBase from "@material-ui/core/InputBase";
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver";
import { ListItemSecondaryAction, Tooltip, IconButton, DialogContent, DialogActions } from "@material-ui/core";
import ClearIcon from "@material-ui/icons/Clear";
import SystemLabel from "../../../../../system/SystemLabel/SystemLabel";
import GavelIcon from "@material-ui/icons/Gavel";
import AddIcon from "@material-ui/icons/Add";
import Popper from "@material-ui/core/Popper";
import Fade from "@material-ui/core/Fade";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { securityHelper } from "../../../../../helpers/securityHelper";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import AvTimerOutlinedIcon from "@material-ui/icons/AvTimerOutlined";
import { InputGroup, InputGroupAddon, InputGroupText, Input, FormGroup, Label } from "reactstrap";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import DeleteIcon from "@material-ui/icons/Delete";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import PersonIcon from "@material-ui/icons/Person";

const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },
  search: {
    position: "relative",
    backgroundColor: "#3a3b3c",
    borderRadius: 5,
    marginRight: theme.spacing(2),
    marginLeft: 10,
    marginRight: 10,
    width: "calc(100% - 10px)",
    [theme.breakpoints.up("sm")]: {
      marginLeft: 0,
      marginLeft: 10,
      marginRight: 10,
      width: "calc(100% - 10px)",
    },
  },
  searchW: {
    position: "relative",
    backgroundColor: "#eee",
    borderRadius: 5,
    marginRight: theme.spacing(2),
    marginLeft: 10,
    marginRight: 10,
    width: "calc(100% - 10px)",
    [theme.breakpoints.up("sm")]: {
      marginLeft: 0,
      marginLeft: 10,
      marginRight: 10,
      width: "calc(100% - 10px)",
    },
  },
  searchIconW: {
    padding: theme.spacing(0, 2),
    height: "100%",
    color: "#222",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    color: "#FFFFFF99",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
  },
  inputInputW: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    color: "#222",
    [theme.breakpoints.up("md")]: {
      width: "100%",
    },
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    color: "#FFFFFF99",
    [theme.breakpoints.up("md")]: {
      width: "100%",
    },
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  online: {
    background: "#44b700",
  },
  offline: {
    background: "orangered",
  },
}));

const OnlineBadge = withStyles((theme) => ({
  badge: {
    backgroundColor: "#44b700",
    color: "#44b700",
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "$ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: '""',
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}))(Badge);

const OfflineBadge = withStyles((theme) => ({
  badge: {
    backgroundColor: "orangered",
    color: "orangered",
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "$ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: '""',
    },
  },
}))(Badge);

export default function SpeakerList(props) {
  const [filter, setFilter] = React.useState("");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const [dialogOpen, setDialogOpen] = React.useState(false);

  const handleClickOpen = () => {
    setDialogOpen(true);
  };

  const handleClose = (value) => {
    setDialogOpen(false);
  };

  const searchFilter = (e) => {
    setFilter(e.target.value);
  };
  const sortSpeakers = (speakers) => {
    return speakers
      .sort(function (a, b) {
        return a.sortOrder - b.sortOrder;
      })
      .sort(function (a, b) {
        return b.speakerType - a.speakerType;
      });
  };
  const isSpeakerActivationAllowed = (speakerId) => {
    const { speakers } = props;
    if (speakers.find((s) => s.interactionSpeakerId === speakerId && s.active === true)) return true;
    else if (speakers.find((s) => s.active === true)) return false;
    else return true;
  };
  const renderClosedSpeakers = () => {
    const { speakers } = props;
    return sortSpeakers(speakers)
      .filter((s) => s.parentInteractionSpeakerId === null && s.closedDateTime !== null && !s.active)
      .map((s, i) => {
        return renderSpeakerCard(s, true);
      });
  };

  const renderTimeBadge = (time, level = null) => {
    let top = level ? 25 + level * 60 + "px" : "25px";

    return (
      <div style={{ position: "absolute", left: "-30px", top: top, backgroundColor: "#f44336", color: "#fff", padding: "2px 6px", borderRadius: 25, fontSize: "10px" }}>
        <div>{time}</div>
        <div />
      </div>
    );
  };
  const canBeActivated = (aId) => {
    const { activeAgenda } = props;
    if (activeAgenda && activeAgenda.agendaItemId === aId) return true;
    return false;
  };
  const formatTime = (date) => {
    if (!date) return null;
    let formattedDate = new Date(date);
    let h = formattedDate.getHours();
    let m = formattedDate.getMinutes();
    if (m < 10) m = "0" + m;
    if (h < 10) h = "0" + h;
    return h + ":" + m;
  };
  const renderSpeakerCard = (speaker, addTimeStamp = false) => {
    const { clientList, allClients } = props;
    const client = allClients.find((ac) => ac.badgeNo === speaker.badgeNo);
    let online = client ? clientList.find((cl) => cl.clientKey === client.badgeNo) : false;
    if (!client) return null;
    return (
      <Card className="dark-card" style={{ padding: " 0px", margin: 5, backgroundColor: speaker.closedDateTime !== null ? "#dcdcdc" : "#fff", overflow: "visible", position: "relative" }}>
        {addTimeStamp ? <div style={{ position: "absolute", height: "90%", borderLeft: "2px solid rgb(224, 42, 34)", left: "-12px" }} /> : null}
        {addTimeStamp && speaker.closedDateTime && !speaker.active ? renderTimeBadge(formatTime(speaker.closedDateTime)) : null}
        <ListItem>
          {speaker.speakerType === 3 ? (
            <ListItemAvatar>
              <GavelIcon className="secondary-text" />
            </ListItemAvatar>
          ) : null}
          <ListItemAvatar>
            {online && client !== undefined ? (
              <OnlineBadge
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                overlap="circle"
                variant="dot"
              >
                <Avatar style={{ backgroundColor: "#864ace" }}>{client !== undefined ? `${client.nameInitials}` : null}</Avatar>
              </OnlineBadge>
            ) : (
              <OfflineBadge
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                overlap="circle"
                variant="dot"
              >
                <Avatar style={{ backgroundColor: "#864ace" }}>{client !== undefined ? `${client.nameInitials}` : null}</Avatar>
              </OfflineBadge>
            )}
          </ListItemAvatar>
          <ListItemText className="primary-text" primary={client !== undefined ? `${client.name}` : ""} />
          <ListItemSecondaryAction style={{ display: "inline-flex" }}>
            {canBeActivated(speaker.agendaItemId) ? (
              /*     <TimePopper
                active={speaker.active}
                disabled={!isSpeakerActivationAllowed(speaker.interactionSpeakerId)}
                badgeNo={client.badgeNo}
                id={speaker.interactionSpeakerId}
                activate={props.activateSpeaker}
              /> */
              <IconButton className="icon-button-dark-s" onClick={() => props.activateSpeaker(client.badgeNo, speaker.interactionSpeakerId, 0)} disabled={props.disabled} edge="end">
                <Tooltip title={!speaker.active ? <SystemLabel name="ActivateSpeaker" /> : <SystemLabel name="DeactivateSpeaker" />}>
                  {speaker.active ? <ClearIcon /> : <RecordVoiceOverIcon />}
                </Tooltip>
              </IconButton>
            ) : null}
            <IconButton
              className="icon-button-dark-s"
              style={{ marginLeft: "5px" }}
              disabled={speaker.active}
              onClick={() => props.removeSpeaker(speaker.agendaItemId, speaker.badgeNo, speaker.parentInteractionSpeakerId)}
            >
              <DeleteIcon style={{ marginTop: "-3px" }} />
            </IconButton>
          </ListItemSecondaryAction>
        </ListItem>
        <div>
          {sortSpeakers(speakers)
            .filter((ss) => ss.parentInteractionSpeakerId === speaker.interactionSpeakerId && ss.speakerType === 3)
            .map((ss, i) => {
              let gavelClient = allClients.find((ac) => ac.badgeNo === ss.badgeNo);
              let online = clientList.find((cl) => cl.clientKey === gavelClient.badgeNo);
              return (
                <React.Fragment>
                  <Card key={i} className="dark-card" style={{ padding: " 0px", margin: 5, backgroundColor: ss.closedDateTime !== null ? "#eee" : "#fff" }}>
                    {addTimeStamp && ss.closedDateTime && !ss.active ? renderTimeBadge(formatTime(ss.closedDateTime), i + 1) : null}
                    <ListItem>
                      <ListItemAvatar>
                        <GavelIcon className="secondary-text" />
                      </ListItemAvatar>
                      <ListItemAvatar>
                        {online && gavelClient ? (
                          <OnlineBadge
                            anchorOrigin={{
                              vertical: "bottom",
                              horizontal: "right",
                            }}
                            overlap="circle"
                            variant="dot"
                          >
                            <Avatar style={{ backgroundColor: "#864ace" }}>{gavelClient !== undefined ? `${gavelClient.nameInitials}` : null}</Avatar>
                          </OnlineBadge>
                        ) : (
                          <OfflineBadge
                            anchorOrigin={{
                              vertical: "bottom",
                              horizontal: "right",
                            }}
                            overlap="circle"
                            variant="dot"
                          >
                            <Avatar style={{ backgroundColor: "#864ace" }}>{gavelClient !== undefined ? `${gavelClient.nameInitials}` : null}</Avatar>
                          </OfflineBadge>
                        )}
                      </ListItemAvatar>
                      <ListItemText className="primary-text" primary={gavelClient !== undefined ? `${gavelClient.name}` : null} />
                      <ListItemSecondaryAction style={{ display: "inline-flex" }}>
                        {canBeActivated(ss.agendaItemId) ? (
                          /*   <TimePopper
                            active={ss.active}
                            disabled={!isSpeakerActivationAllowed(ss.interactionSpeakerId)}
                            badgeNo={gavelClient.badgeNo}
                            id={ss.interactionSpeakerId}
                            activate={props.activateSpeaker}
                          /> */
                          <IconButton
                            className="icon-button-dark-s"
                            onClick={() => props.activateSpeaker(gavelClient.badgeNo, ss.interactionSpeakerId, 0)}
                            disabled={props.disabled}
                            edge="end"
                            /*   onClick={() => props.activateSpeaker(lineClient.order.badgeNo, speaker.interactionSpeakerId)} */
                          >
                            <Tooltip title={!ss.active ? <SystemLabel name="ActivateSpeaker" /> : <SystemLabel name="DeactivateSpeaker" />}>
                              {ss.active ? <ClearIcon /> : <RecordVoiceOverIcon />}
                            </Tooltip>
                          </IconButton>
                        ) : null}
                        <IconButton
                          className="icon-button-dark-s"
                          style={{ marginLeft: "5px" }}
                          disabled={ss.active}
                          onClick={() => props.removeSpeaker(ss.agendaItemId, ss.badgeNo, ss.parentInteractionSpeakerId)}
                        >
                          <DeleteIcon style={{ marginTop: "-3px" }} />
                        </IconButton>
                      </ListItemSecondaryAction>
                    </ListItem>
                  </Card>
                </React.Fragment>
              );
            })}
        </div>
        <div>
          {sortSpeakers(speakers)
            .filter((ss) => ss.parentInteractionSpeakerId === speaker.interactionSpeakerId && ss.speakerType !== 3)
            .map((ss, i) => {
              let lineClient = allClients.find((ac) => ac.badgeNo === ss.badgeNo);
              let online = clientList.find((cl) => cl.clientKey === lineClient.badgeNo);
              return (
                <React.Fragment>
                  <Card
                    key={i}
                    className="dark-card"
                    style={{
                      margin: 5,
                      marginLeft: 55,
                      backgroundColor: "#eee",
                      backgroundColor: ss.closedDatetime !== null ? "#eee" : "#fff",
                    }}
                  >
                    {addTimeStamp && ss.closedDateTime && !ss.active ? renderTimeBadge(formatTime(ss.closedDateTime), i + 1) : null}
                    <ListItem>
                      <ListItemAvatar>
                        <i className="fa fa-bullhorn secondary-text" style={{ fontSize: 22 }} />
                      </ListItemAvatar>
                      <ListItemAvatar>
                        {online && lineClient ? (
                          <OnlineBadge
                            anchorOrigin={{
                              vertical: "bottom",
                              horizontal: "right",
                            }}
                            overlap="circle"
                            variant="dot"
                          >
                            <Avatar style={{ backgroundColor: "#864ace" }}>{lineClient !== undefined ? `${lineClient.nameInitials}` : null}</Avatar>
                          </OnlineBadge>
                        ) : (
                          <OfflineBadge
                            anchorOrigin={{
                              vertical: "bottom",
                              horizontal: "right",
                            }}
                            overlap="circle"
                            variant="dot"
                          >
                            <Avatar style={{ backgroundColor: "#864ace" }}>{lineClient !== undefined ? `${lineClient.nameInitials}` : null}</Avatar>
                          </OfflineBadge>
                        )}
                      </ListItemAvatar>
                      <ListItemText className="primary-text" primary={lineClient !== undefined ? `${lineClient.name}` : ""} />
                      <ListItemSecondaryAction style={{ display: "inline-flex" }}>
                        {canBeActivated(ss.agendaItemId) ? (
                          /*   <TimePopper
                            active={ss.active}
                            disabled={!isSpeakerActivationAllowed(ss.interactionSpeakerId)}
                            badgeNo={lineClient.badgeNo}
                            id={ss.interactionSpeakerId}
                            activate={props.activateSpeaker}
                          /> */

                          <IconButton className="icon-button-dark-s" onClick={() => props.activateSpeaker(lineClient.badgeNo, ss.interactionSpeakerId, 0)} disabled={props.disabled} edge="end">
                            <Tooltip title={!ss.active ? <SystemLabel name="ActivateSpeaker" /> : <SystemLabel name="DeactivateSpeaker" />}>
                              {ss.active ? <ClearIcon /> : <RecordVoiceOverIcon />}
                            </Tooltip>
                          </IconButton>
                        ) : null}

                        <IconButton
                          className="icon-button-dark-s"
                          style={{ marginLeft: "5px" }}
                          disabled={ss.active}
                          onClick={() => props.removeSpeaker(ss.agendaItemId, ss.badgeNo, ss.parentInteractionSpeakerId)}
                        >
                          <DeleteIcon style={{ marginTop: "-3px" }} />
                        </IconButton>
                      </ListItemSecondaryAction>
                    </ListItem>
                  </Card>
                </React.Fragment>
              );
            })}
        </div>
      </Card>
    );
  };
  const classes = useStyles();
  const { filteredClients, clientList, speakers, activeSpeaker } = props;
  return (
    <div style={{ margin: "0px", height: "100%", backgroundColor: "#1d1d1d" }}>
      <div style={{ width: "100%", display: "inline-flex" }}>
        <div className={classes.search}>
          <div className={classes.searchIcon}>
            <SearchIcon />
          </div>
          <InputBase
            onInput={searchFilter}
            placeholder="Search…"
            classes={{
              root: classes.inputRoot,
              input: classes.inputInput,
            }}
            inputProps={{ "aria-label": "search" }}
          />
        </div>
        <IconButton className="icon-button-dark-s" onClick={handleClickOpen} edge style={{ padding: "0px 10px" }}>
          <AddIcon />
        </IconButton>
      </div>
      <List className="dark-list" dense={true} style={{ maxHeight: "calc(100vh - 326px)", maxHeight: "calc(100vh - 326px)", marginTop: 10, overflowY: "auto" }}>
        <div style={{ marginLeft: 30 }}>{renderClosedSpeakers()}</div>
        {speakers
          ? sortSpeakers(speakers)
              .filter((s) => (s.parentInteractionSpeakerId === null && s.closedDateTime === null) || (s.parentInteractionSpeakerId === null && s.closedDateTime != null && s.active))
              .map((s, i) => {
                return renderSpeakerCard(s);
              })
          : null}
      </List>
      {dialogOpen ? <SimpleDialog handleClose={handleClose} {...props} /> : null}
    </div>
  );
}

function SpeakerListItems(props) {
  const { clientList, allClients, speakers, filter } = props;
  return (
    <List className="dark-list">
      {allClients
        .filter((ac) => !speakers.find((s) => s.badgeNo === ac.badgeNo) && ac.name.toLowerCase().includes(filter.toLowerCase()))
        .map((ac, i) => {
          const client = ac;
          let online = clientList.find((cl) => cl.clientKey === client.badgeNo);
          return (
            <ListItem style={{ margin: "10px 0px" }}>
              <ListItemAvatar>
                {online ? (
                  <OnlineBadge
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    overlap="circle"
                    variant="dot"
                  >
                    <Avatar style={{ backgroundColor: "#864ace" }}>{`${client.nameInitials}`}</Avatar>
                  </OnlineBadge>
                ) : (
                  <OfflineBadge
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    overlap="circle"
                    variant="dot"
                  >
                    <Avatar style={{ backgroundColor: "#864ace" }}>{`${client.nameInitials}`}</Avatar>
                  </OfflineBadge>
                )}
              </ListItemAvatar>
              <ListItemText primary={`${client.name}`} />
              <ListItemSecondaryAction>
                {props.selectedSpeakers && !props.selectedSpeakers.includes(client.badgeNo) ? (
                  <Button color="primary" onClick={() => props.addSpeaker(client.badgeNo)}>
                    <SystemLabel name="Add" />
                  </Button>
                ) : (
                  <Button color="error" onClick={() => props.removeSpeaker(client.badgeNo)}>
                    <SystemLabel name="Remove" />
                  </Button>
                )}
              </ListItemSecondaryAction>
            </ListItem>
          );
        })}
    </List>
  );
}

function SimpleDialog(props) {
  const [speakers, setSpeakers] = React.useState([]);
  const { handleClose, agendaItemId, setSpeaker } = props;
  const [filter, setFilter] = React.useState("");

  const searchFilter = (e) => {
    setFilter(e.target.value);
  };

  const onSelect = (clientKey) => {
    const newSpeakers = Array.from(speakers);
    newSpeakers.push(clientKey);
    setSpeakers(newSpeakers);
  };
  const onRemove = (clientKey) => {
    let newSpeakers = Array.from(speakers);
    newSpeakers = newSpeakers.filter((s) => s !== clientKey);
    setSpeakers(newSpeakers);
  };
  const save = () => {
    speakers.map((s) => {
      setSpeaker(agendaItemId, 1, s, null);
    });
    setSpeakers([]);
  };
  const classes = useStyles();
  return (
    <Dialog scroll={"paper"} fullWidth={true} maxWidth={"sm"} maxHeight={"60vh"} minHeight={"60vh"} onClose={handleClose} aria-labelledby="simple-dialog-title" open={true}>
      <DialogTitle id="simple-dialog-title">
        {" "}
        <SystemLabel name="AddSpeaker" />
      </DialogTitle>
      <div style={{ width: "100%", display: "inline-flex", padding: "0px 10px", margin: "5px 0px" }}>
        <div className={classes.searchW}>
          <div className={classes.searchIconW}>
            <SearchIcon />
          </div>
          <InputBase
            onInput={searchFilter}
            placeholder="Search…"
            classes={{
              root: classes.inputRoot,
              input: classes.inputInputW,
            }}
            inputProps={{ "aria-label": "search" }}
          />
        </div>
      </div>
      <DialogContent style={{ minHeight: "60vh" }} dividers={true}>
        <SpeakerListItems addSpeaker={onSelect} filter={filter} selectedSpeakers={speakers} removeSpeaker={onRemove} {...props} />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          <SystemLabel name="Cancel" />
        </Button>
        <Button disabled={speakers.length === 0} onClick={save} color="primary">
          <SystemLabel name="Save" />
        </Button>
      </DialogActions>
    </Dialog>
  );
}

SimpleDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired,
};

function TimePopper(props) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [duration, setDuration] = React.useState(1);

  const handleClick = (event) => {
    if (event === null) setAnchorEl(null);
    else setAnchorEl(event.currentTarget);
  };
  const onActivate = () => {
    const { badgeNo, id, activate } = props;
    activate(badgeNo, id, duration);
    handleClick(null);
  };

  const open = Boolean(anchorEl) && props.active === false;
  const id = open ? "simple-popper" : undefined;

  return (
    <div>
      {/*   <button aria-describedby={id} type="button" onClick={handleClick}>
                Toggle Popper
             </button> */}

      <IconButton
        className="icon-button-dark-s"
        aria-describedby={id}
        onClick={props.active ? onActivate : handleClick}
        disabled={props.disabled}
        edge="end"
        /*   onClick={() => props.activateSpeaker(lineClient.order.badgeNo, speaker.interactionSpeakerId)} */
      >
        <Tooltip title={<SystemLabel name="ActivateSpeaker" />}>{props.active ? <ClearIcon /> : <RecordVoiceOverIcon />}</Tooltip>
      </IconButton>
      <Popper id={id} open={open} anchorEl={anchorEl} style={{ zIndex: 100 }} placement="top" transition>
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Paper style={{ padding: 10 }}>
              <FormGroup style={{ marginBottom: 0 }}>
                {/*   <Label ><SystemLabel name="SpeakerDuration" /></Label> */}
                <InputGroup>
                  <InputGroupAddon style={{ padding: "5px 10px", color: "rgb(103, 103, 103)" }} addonType="prepend">
                    <AvTimerOutlinedIcon />
                  </InputGroupAddon>
                  <Input value={duration} step={0.5} onChange={(e) => setDuration(e.target.value)} type="number" />
                  <InputGroupAddon addonType="append">
                    <Button onClick={onActivate}>OK</Button>
                  </InputGroupAddon>
                  <InputGroupAddon addonType="append">
                    <Button onClick={handleClick}>
                      <SystemLabel name="Cancel" />
                    </Button>
                  </InputGroupAddon>
                </InputGroup>
              </FormGroup>
              <div style={{ paddingLeft: 44 }}>
                <p style={{ margin: 0, fontStyle: "italic", color: "gray", fontSize: 12 }}>
                  <SystemLabel name="minutes" />
                </p>
              </div>
            </Paper>
          </Fade>
        )}
      </Popper>
    </div>
  );
}
